import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const certifications: string[] = [
  'Dare to Lead por BetterUp',
  'Women in Leadership por Linkage Inc.',
  'Positive Psychology: The Happiness Advantage, por Shawn Achor',
  'HR Leadership por Thunderbird School of Global Management',
  'Change Management por Prosci',
  'Effective Management por ICAMI',
  'Certificación EC0204 de coaching y mentoría',
  'Maestría en Desarrollo Organizacional por la Universidad Iberoamericana',
  'Ingeniería en Sistemas Computacionales por la UNIVA',
];

interface Expectation {
  title: string;
  description: string;
}

const expectationsLeft: Expectation[] = [
  {
    title: 'Confidencialidad',
    description: 'Conversaciones seguras para explorar desafíos y oportunidades.',
  },
  {
    title: 'Preguntas y reflexiones',
    description: 'Para ayudarte a ampliar tu perspectiva sobre esos desafíos y oportunidades.',
  },
  {
    title: 'Acompañamiento respetuoso y sin juicios',
    description: 'Aunque no siempre será fácil... el propósito es ayudarte a crecer más allá de tu zona de confort.',
  },
];

const expectationsRight: Expectation[] = [
  {
    title: 'Aprendizaje',
    description: 'A través de ejemplos, recursos y otras experiencias que sirvan para tu proceso de crecimiento.',
  },
  {
    title: 'Estímulo',
    description: 'Para experimentar y probar nuevas formas que al principio pueden resultar incómodas.',
  },
];

export default function SobreMiPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-50">
        {/* Header */}
        <section className="w-full pt-24 pb-8 md:pt-32 md:pb-12">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-[0.02em] text-foreground-900 leading-[1.05]">
              SOBRE MÍ
            </h1>
            <div className="mt-6">
              <p className="text-xl md:text-2xl font-medium text-foreground-900">
                Erika López Castañeda
              </p>
              <p className="text-sm md:text-base text-foreground-600 mt-1">
                Mentora de Reflexión Estratégica
              </p>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="w-full h-px bg-background-300/60" />
        </div>

        {/* Sección 1 — Foto + Perfil + Certificaciones */}
        <section className="w-full py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="flex gap-6 md:gap-10 lg:gap-16">
              {/* Número grande */}
              <div className="flex-shrink-0 hidden md:block">
                <span className="font-heading text-7xl lg:text-8xl font-light text-accent-500 leading-none">
                  1
                </span>
              </div>

              {/* Contenido */}
              <div className="flex-1 grid grid-cols-1 lg:grid-cols-[240px_1fr_1fr] gap-10 lg:gap-12">
                {/* Columna foto — editorial */}
                <div className="order-1 lg:order-1 flex flex-col items-center lg:items-start">
                  <div className="relative w-full max-w-[190px] lg:max-w-[200px] aspect-[3/4] overflow-hidden rounded-lg">
                    <img
                      src="https://storage.helloreaddy.io/project_files/051d548c-4efa-4d12-87d7-897fd5389524/b62278c4-e49c-427a-bfad-0f6cc626b5ec_compressed_WhatsApp-Image-2026-10-03-at-1.54.14-PM.webp"
                      alt="Erika López Castañeda"
                      className="w-full h-full object-cover object-top saturate-[0.7] contrast-[1.05]"
                    />
                  </div>
                  <div className="mt-4 flex flex-col items-center lg:items-start">
                    <span className="text-[10px] tracking-[0.2em] uppercase text-foreground-500 font-medium">
                      Erika López Castañeda
                    </span>
                    <span className="text-[10px] tracking-[0.15em] uppercase text-foreground-400 mt-0.5">
                      Mentora de Reflexión Estratégica
                    </span>
                  </div>
                </div>

                {/* Columna izquierda — Texto */}
                <div className="order-2 lg:order-2 space-y-5">
                  <p className="text-sm font-semibold text-foreground-700 tracking-wide">
                    Reflexiva. Respetuosa. Directa. Cercana.
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    Aplico mi experiencia como ejecutiva global y mi especialización en liderazgo para ayudar a líderes a alcanzar su máximo potencial a través de un método propio de mentoría estratégica.
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    Después de 20 años y una carrera progresiva en distintos roles de Recursos Humanos y desarrollo organizacional, dentro de un entorno corporativo global, te ofrezco la experiencia y la perspectiva necesarias para ayudarte a potenciar tu talento.
                  </p>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    Creo firmemente que las mejores decisiones nacen cuando hay calma interna, claridad mental y congruencia personal.
                  </p>
                </div>

                {/* Columna derecha — Certificaciones */}
                <div className="order-3 lg:order-3">
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-5">
                    Mis certificaciones
                  </h3>
                  <ul className="space-y-2">
                    {certifications.map((cert, i) => (
                      <li key={i} className="text-xs md:text-sm text-foreground-600 leading-relaxed flex items-start gap-2">
                        <span className="mt-1.5 w-1 h-1 rounded-full bg-accent-400 flex-shrink-0" />
                        {cert}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="w-full h-px bg-background-300/60" />
        </div>

        {/* Sección 2 — Expectativas */}
        <section className="w-full py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="flex gap-6 md:gap-10 lg:gap-16">
              {/* Número grande */}
              <div className="flex-shrink-0 hidden md:block">
                <span className="font-heading text-7xl lg:text-8xl font-light text-accent-500 leading-none">
                  2
                </span>
              </div>

              {/* Contenido */}
              <div className="flex-1">
                <h2 className="text-base md:text-lg font-semibold text-foreground-900 mb-8">
                  ¿Qué puedes esperar durante un proceso de Mentoría Estratégica con Erika?
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-5">
                  {/* Columna izquierda */}
                  <div className="space-y-5">
                    {expectationsLeft.map((item, i) => (
                      <div key={i} className="flex items-start gap-2">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0" />
                        <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                          <span className="font-semibold text-foreground-800">{item.title}</span>{' '}
                          {item.description}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Columna derecha */}
                  <div className="space-y-5">
                    {expectationsRight.map((item, i) => (
                      <div key={i} className="flex items-start gap-2">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0" />
                        <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                          <span className="font-semibold text-foreground-800">{item.title}</span>{' '}
                          {item.description}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
          <div className="w-full h-px bg-background-300/60" />
        </div>

        {/* Sección 3 — CTA */}
        <section className="w-full py-12 md:py-16">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="flex gap-6 md:gap-10 lg:gap-16 items-start">
              {/* Número grande */}
              <div className="flex-shrink-0 hidden md:block">
                <span className="font-heading text-7xl lg:text-8xl font-light text-accent-500 leading-none">
                  3
                </span>
              </div>

              {/* Contenido */}
              <div className="flex-1 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <p className="text-base md:text-lg text-foreground-700 leading-relaxed max-w-xl">
                  ¿Te gustaría llevar tu crecimiento profesional al siguiente nivel?
                </p>
                <Link
                  to="/agenda"
                  className="inline-block px-8 py-3.5 rounded-md text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer bg-accent-500 text-background-50 hover:bg-accent-600"
                >
                  Agenda una sesión
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}